// src/pages/PaymentManagement/RevenueStats.js
import React, { useState, useEffect } from 'react';
import { paymentService } from '../../services/paymentService';
import { useLanguage } from '../../contexts/LanguageContext';

const RevenueStats = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [period, setPeriod] = useState('today');
    const { t } = useLanguage();

    useEffect(() => {
        loadStats();
    }, [period]);

    const loadStats = async () => {
        try {
            setLoading(true);
            const response = await paymentService.getPaymentStats(period);
            if (response.success) {
                setStats(response.data);
            }
        } catch (error) {
            console.error(t('loadStatsError'), error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div>{t('loading')}</div>
            </div>
        );
    }

    if (!stats) {
        return (
            <div className="no-data">
                <p>{t('noStatsAvailable')}</p>
            </div>
        );
    }

    return (
        <div className="revenue-stats">
            <div className="page-header">
                <h1>{t('revenueStats')}</h1>
                <p>{t('revenueStatsDescription')}</p>
            </div>

            <div className="stats-content">
                {/* Period Selector */}
                <div className="period-selector">
                    <select value={period} onChange={(e) => setPeriod(e.target.value)}>
                        <option value="today">{t('today')}</option>
                        <option value="week">{t('thisWeek')}</option>
                        <option value="month">{t('thisMonth')}</option>
                        <option value="year">{t('thisYear')}</option>
                    </select>
                </div>

                {/* Genel İstatistikler */}
                <div className="stats-grid">
                    <div className="stat-card revenue">
                        <div className="stat-value">
                            {stats.paymentStatistics?.total_revenue || 0} TL
                        </div>
                        <div className="stat-label">{t('totalRevenue')}</div>
                    </div>

                    <div className="stat-card payments">
                        <div className="stat-value">
                            {stats.paymentStatistics?.total_payments || 0}
                        </div>
                        <div className="stat-label">{t('totalPayments')}</div>
                    </div>

                    <div className="stat-card completed">
                        <div className="stat-value">
                            {stats.paymentStatistics?.completed_payments || 0}
                        </div>
                        <div className="stat-label">{t('completedPayments')}</div>
                    </div>

                    <div className="stat-card avg-amount">
                        <div className="stat-value">
                            {stats.paymentStatistics?.avg_amount || 0} TL
                        </div>
                        <div className="stat-label">{t('averageAmount')}</div>
                    </div>
                </div>

                {/* Plan Bazlı Gelir */}
                <div className="plan-breakdown">
                    <h3>{t('revenueByPlan')}</h3>
                    <div className="plan-stats">
                        {stats.statistics?.planBreakdown?.map(plan => (
                            <div key={plan.plan} className="plan-stat">
                                <div className="plan-name">{plan.plan}</div>
                                <div className="plan-revenue">{plan.revenue || 0} TL</div>
                                <div className="plan-count">({plan.count} {t('payments')})</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Basit Grafik Alanı (ileride chart eklenecek) */}
                <div className="chart-placeholder">
                    <h3>{t('revenueChart')}</h3>
                    <div className="placeholder-content">
                        <p>{t('chartPlaceholder')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RevenueStats;